import React, { useState } from "react";
import { fichiersService } from "../../services";
import { CustomDialog, Loading, showToast } from "..";
import { Fichier } from "../../interfaces/fichier";
import { useQueryClient } from "@tanstack/react-query";

interface ModalDeleteFichierProps {
  modalIsOpenDelete: boolean;
  closeModalDelete: () => void;
  selectedFichier: Fichier;
}
const ModalDeleteFichier = ({
  modalIsOpenDelete,
  closeModalDelete,
  selectedFichier,
}: ModalDeleteFichierProps) => {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const deleteFichier = async (id) => {
    try {
      setLoading(true);
      await fichiersService.delete(id);
      setLoading(false);
      showToast("info", "fichier supprimé");
      queryClient.refetchQueries({
        queryKey: ["fichiers"],
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };
  return (
    <>
      <CustomDialog
        visible={modalIsOpenDelete}
        closeModalDialog={() => {
          closeModalDelete();
        }}
      >
        <div className="relative w-full h-full">
          <div className="text-center">
            <svg
              aria-hidden="true"
              className="mx-auto mb-4 text-gray-400 w-14 h-14 "
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>

            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Êtes-vous sûr de supprimer ce fichier ?
            </h3>

            <button
              data-modal-hide="popup-delete"
              type="button"
              onClick={() => {
                deleteFichier(selectedFichier.id);
                closeModalDelete();
              }}
              className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
            >
              Oui, je suis sûr
            </button>
            <button
              onClick={closeModalDelete}
              type="button"
              className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 "
            >
              Non, annuler
            </button>
          </div>
        </div>
      </CustomDialog>
      {loading && <Loading />}
    </>
  );
};

export default ModalDeleteFichier;
